import { isBefore, parse, startOfDay } from 'date-fns';
import Cookies from "js-cookie";
import config from '../../scripts/config.json';
import { setCounters, setData, setMenu, setNotifications, setSdk, setVersion } from "../pages/commons/functions";
import { globalStateStore } from "../pages/context/GlobalStateContext";

type FetchWatcher = (url: string, options: RequestInit, response?: Response, error?: any) => void;

let globalWatcher: FetchWatcher | null = null;

export const setGlobalFetchWatcher = (fn: FetchWatcher) => {
  globalWatcher = fn;
};

export const fetchWithWatch = async (url: string, options: RequestInit & { timeout?: number } = {}) => {

  const { timeout = 30000, ...fetchOptions } = options;
  const controller = new AbortController();
  const { signal } = controller;

  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);

  const originalUrl = url;

  try {
    const currentHash = window.location.hash.split('?')[0] || "#";
    fetchOptions.headers = {
      ...fetchOptions.headers,
      "m-routing": currentHash
    };

    // 1. Guard the connection
    const response = await fetch(url, { ...fetchOptions, signal });

    if (!response.ok) {
      let errorBody = "";
      try {
        // Read the error description payload from the server
        errorBody = await response.text();
      } catch (e) {
        errorBody = "Could not read error response body";
      }

      // Create a custom error object containing the server's response content
      const serverError = new Error(`Server Error ${response.status}: ${errorBody}`);
      // Attach the status code and raw body to the error object for debugging downstream
      (serverError as any).status = response.status;
      (serverError as any).body = errorBody;

      // Force execution to jump straight into your catch block
      throw serverError;
    }

    // 2. Pass the signal to globalWatcher if it reads the body streams
    if (globalWatcher) globalWatcher(originalUrl, options, response);

    const cleanUrl = url.split("?")[0];
    if (cleanUrl.endsWith("/routing/v1/")) {
      const clonedResponse = response.clone();
      try {
        // 3. CRITICAL: If reading the text takes longer than the remaining timeout,
        // the controller.abort() will trigger an error right HERE.

        const bodyText = await clonedResponse.text();

        const json = JSON.parse(bodyText);
        let dataTmp = json;

        let currentHash = (window.location.hash).replace("#", "") || '';
        if (json && json.code !== undefined) {
          //console.log(json.JWT)
          //console.log(json.oJWT)
          if (!json.JWT || !json.oJWT && !json.oJWT.valid || json.oJWT.expired) {
            //console.log("Invalidate token: ", json.JWT)
            Cookies.remove("JWT")
            Cookies.set("JWT", "", {
              expires: 7, // cookie expiration in days
              path: "/",     // available on all paths
              sameSite: "strict"
            });
            Cookies.remove("JWT")

            if (!window.location.hash.startsWith("#user/")) {

              let currentHash = (window.location.hash).replace("#", "") || '';
              currentHash = currentHash !== "" ? `?t=1&returnUrl=${encodeURIComponent(currentHash)}` : ""
              window.location.href = `#user/login${currentHash}`;
              //window.location.href = '#user/login'
              return;
            }
          }
          else if (json.code === 0) {
            Cookies.set("JWT", json.JWT, {
              expires: 7, // cookie expiration in days
              path: "/",     // available on all paths
              sameSite: "strict"
            });
          }
        }


        if (!window.location.hash.startsWith("#user/")) {
          if (dataTmp.codeLogin && dataTmp.codeLogin == -1) {
            //setIdUser(0); setJWT(""); setDisplayName("");
            //window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
            return;
          }
          else if (dataTmp.code && dataTmp.code == -10) {
            //setIdUser(0); setJWT(""); setDisplayName("");
            //window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
            return;
          } else if (dataTmp.JWT === "") {
            //setIdUser(0); setJWT(""); setDisplayName("");
            ///window.location.href = `#user/login?t=1&returnUrl=${encodeURIComponent(currentHash)}`;
            return;
          }
        }
        if (json.needsInfoUpdate) {
          if (window.location.hash.indexOf("#user/") === -1) {
            window.location.hash = "#user/profile?NIU=1&returnUrl=" + encodeURIComponent(window.location.hash);
          }
        }
        if (json && json.menu) {
          setMenu(json.menu);
        }
        if (json && json.notifications) {
          setNotifications(json.notifications);
        }
        if (json && json.counters) {
          setCounters(json.counters);
        }

        if (json.UF) {
          setData((prev) => ({
            ...prev,
            UF: json.UF
          }));
        }
        if (json.USD) {
          setData((prev) => ({
            ...prev,
            USD: json.USD
          }));
        }
        if (json.balance) {
          setData((prev) => ({ ...prev, balance: json.balance }));
        }
        if (json.balance45) {
          setData((prev) => ({ ...prev, balance45: json.balance45 }));
        }
        if (json.balanceCasino) {
          setData((prev) => ({ ...prev, balanceCasino: json.balanceCasino }));
        }
        if (json.version) {
          setVersion(json.version);

          if (config && config.version && config.version.toString() !== json.version.toString() && json.version.toString() !== "0.0.0" && window.location.host.includes(".planeadores.cl")) {
            window.location.reload();

          }

        }
        if (json.masters) {
          //saveMasters(json.masters, data)
        }
        if (json.sdk) {
          if (globalStateStore.setSdk) {
            setSdk(json.sdk);
          } else {
            // If the provider isn't ready, retry after a tiny delay or 
            // handle it via a queue/context approach
            console.warn("SDK Setter not ready yet!");
          }
        }
        if (json.pendingACK && json.pendingACK > 0 && !window.location.hash.startsWith("#user/") && !window.location.hash.startsWith("#comm/takenotes")) {
          window.location.hash = "user/acks";
          return;
        }
        if (json.studentCertification && json.studentCertification !== "") {
          const studentCertification = parse(json.studentCertification, "dd-MM-yyyy", new Date())
          const isPastDate = isBefore(studentCertification, startOfDay(new Date()));

          if (isPastDate && !window.location.hash.startsWith("#user/")) {
            window.location.hash = "#user/student"
          }


        }
      } catch (streamError: any) {
        // If the stream download was aborted by the timeout, route it to the main handler
        if (streamError.name === 'AbortError') {
          throw streamError;
        }
        console.warn("⚠️ Response parsing failed:", streamError);
      }
    }

    return response;

  } catch (error: any) {
    // THIS WILL NOW FIRE when the timeout cuts off a slow download!
    if (error.status === 500) {

      const htmlString = error.body;
      const errorMatch = htmlString.match(/<b>\s*Compiler Error Message:\s*<\/b>\s*([^<]+)/i);
      const fileMatch = htmlString.match(/<b>\s*Source File:\s*<\/b>\s*([^&<\n]+)/i);
      const lineMatch = htmlString.match(/<b>\s*Line:\s*<\/b>\s*([0-9]+)/i);
      const codeMatch = htmlString.match(/<pre>([\s\S]*?)<\/pre>/i);
      console.log("Error status->", error.status);

      let cleanCodeSnippet = "";
      if (codeMatch && codeMatch[1]) {
        cleanCodeSnippet = codeMatch[1]
          .replace(/<[^>]*>/g, "").replace(/&quot;/g, '"').trim();
      }
      const compilerError = errorMatch ? errorMatch[1].trim() : "Unknown compiler error";
      const sourceFile = fileMatch ? fileMatch[1].trim() : "Unknown source file";
      const lineNumber = lineMatch ? lineMatch[1].trim() : "Unknown line number";
      const codeSnippet = cleanCodeSnippet;
      const error500 = new Error(`[Backend 500] ${compilerError} (Line ${lineNumber} in ${sourceFile})`);
      (error500 as any).codeSnippet = cleanCodeSnippet; // Store the code snippet on the error object
      (error500 as any).status = 500;

      if (globalWatcher) globalWatcher(originalUrl, options, undefined, error500);
      throw error500;

    }
    if (error.name === 'AbortError') {
      console.log("AbortError")
      const timeoutErr = new Error(`Request timeout: The server took longer than ${timeout}ms.`);
      if (globalWatcher) globalWatcher(originalUrl, options, undefined, timeoutErr);
      throw timeoutErr;
    }

    if (globalWatcher) globalWatcher(originalUrl, options, undefined, error);
    throw error;

  } finally {
    clearTimeout(timeoutId);
  }
};
